import React from 'react'
import { Link } from 'gatsby'
import * as Scroll from 'react-scroll';

import ruksLogo from '../img/ruksLogo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faGithub , faFacebook,faLinkedin, faStackOverflow} from '@fortawesome/free-brands-svg-icons'

const BlogNavbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
    }
  }

  
  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: 'is-active',
            })
          : this.setState({
              navBarActiveClass: '',
            })
      }
    )
  }

 

  render() {
    let ScrollLink       = Scroll.Link;
    const iconstyle = {
      color: "#999999",
      
    };
    return (
      <div style={{paddingBottom:2,backgroundColor:'#252525'}}>
      <nav
        className="navbar is-black is-fixed-top"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container" >
          <div className="navbar-brand" style={{marginLeft:5,alignItems:'center'}}>
            <Link to="/"  title="Logo" >
              <img src={ruksLogo} alt="rukstech" />
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <Link className="navbar-item" to="/">
                Home
              </Link>
            
              
              <Link className="navbar-item" to="/blog">
                Blog
              </Link>

             
            </div>
           
            <div className="navbar-end has-text-centered">
              <a
                className="navbar-item"
                href="https://www.linkedin.com/in/rukmoninagarajan/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span >
                <FontAwesomeIcon icon={faLinkedin} style={iconstyle} /> </span></a>
                <a
                className="navbar-item"
                href="https://www.facebook.com/ruksa.be"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span > <FontAwesomeIcon icon={faFacebook} style={iconstyle}/></span>
                </a>
                <a
                className="navbar-item"
                href="https://stackoverflow.com/users/4352480/rukmoni-nagarajan"
                target="_blank"
                rel="noopener noreferrer"
              >
               <span> <FontAwesomeIcon icon={faStackOverflow} style={iconstyle}/>
               
                  
                </span></a>
                <a
                className="navbar-item"
                href="https://github.com/Rukmoni"
                target="_blank"
                rel="noopener noreferrer"
              >
               <span> <FontAwesomeIcon icon={faGithub} style={iconstyle}/>
               
                  
                </span></a>
              
            </div>
           
          </div>
        </div>
      </nav>
      </div>
    )
  }
}

export default BlogNavbar
